<template>
  <div>
    <v-autocomplete
        :value="value"
        :items="selectItems"
        placeholder="Choose value"
        hide-details
        outlined
        dense
        @input="$emit('input', $event)"
    />
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'MedicationRoute',
  props: {
    value: {
      default: null,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selectItems() {
      const items = [];

      if (this.field.values) {
        _.forEach(this.field.values, (text, code) => {
          items.push({
            text: (this.field.displayValue ? `${code} - ` : '') + text,
            value: code,
          });
        });
      }

      if (this.field.historicalValues) {
        items.push({ divider: true });
        items.push({ header: 'Historical values' });
        _.forEach(this.field.historicalValues, (text, code) => {
          items.push({
            text: `${code} - ${text}`,
            value: code,
          });
        });
      }

      return items;
    },
  },
};
</script>
